<div class="flex-c gap-16 max-width-800 padding-bottom-48 align-self-stretch">
  @if (!isLoading) {
    @for (promoCode of promoCodes; track $index) {
      <app-coupon-code
        style="min-height: 164px"
        [couponCode]="promoCode"
        (couponDeleted)="onCouponCodeDeleted($event)"
        (couponEditRequested)="editPromoCode($event)"
        (couponActiveStateChanged)="
          onCouponCodeActiveStateChanged($event, promoCode.id)
        "></app-coupon-code>
    }
    <p-divider type="dashed" class="divider-with-button padding-12-0">
      <button class="circle-medium" (click)="addPromoCode()">
        <i class="fa-solid fa-plus circle-icon"></i>
      </button>
    </p-divider>
  } @else {
    @for (item of [].constructor(4); track $index) {
      <p-skeleton width="100%" height="164px"></p-skeleton>
    }
  }
</div>
